import {ThemeVariablesType} from '@yosmanyga/theme';

export const build = (variables: ThemeVariablesType) => {
    const {palette} = variables;

    return {
        html: {
            margin: 0,
            height: '100%'
        },
        body: {
            margin: 0,
            background: palette.brand1['1000'],
            height: '100%'
        },
        p: {
            margin: 0,
        }
    };
};
